import angular from 'angular';

angular
  .module('dashboard')

  .factory('Files', [
    '$http',
    'CONF',
    'API_CONFIG',
    function($http, CONF, API_CONFIG) {
      var File = {};

      File.download = function(fileId) {
        return API_CONFIG.url + '/v1/file/' + fileId;
      };

      File.downloadIndexFile = function(fileId, fileType) {
        return API_CONFIG.url + '/v1/file/' + fileId + '/' + fileType;
      };

      return File;
    }
  ]);
